import {
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { IOption, IPagination } from "../../data/AppInterface";
import {
  TBitValue,
  TReactSetState,
  TSetPaginationFn,
  TUseTranslationTfn,
} from "../../data/AppType";
import { GET_ALL_BRANCH, GLOBAL_DROP_DOWN } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { BIT_VALUE } from "../../utils/AppEnumerations";
import {
  decryptData,
  handleError,
  sweetAlertError,
  toastError,
} from "../../utils/AppFunctions";

export interface IBranch {
  id: string;
  branch_name: string;
  contact_person_name: string | null;
  contact_person_mobile: string;
  contact_person_email: string;
  firm_name: string;
  is_active: TBitValue;
  is_deleted: TBitValue;
}

export interface IBranchAdvancedSearch {
  firmId: string | null;
  sd: TBitValue;
}

export const BRANCH_ADVANCE_SEARCH_INITIAL_VALUE = {
  firmId: null,
  sd: BIT_VALUE.Zero,
};

export function getBranchFields<T>(
  actionComponent: (item: T) => JSX.Element,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("branch_name"),
      key: "branch_name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("firm_name"),
      key: "firm_name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("contact_person_name"),
      key: "contact_person_name",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-3",
    },
    {
      name: t("contact_person_mobile"),
      key: "contact_person_mobile",
      sort: false,
      type: TABLE_FIELD_TYPE.mask,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-3",
      maskingRegex: /(\d{5})$/,
    },
    {
      name: t("contact_person_email"),
      key: "contact_person_email",
      sort: false,
      type: TABLE_FIELD_TYPE.mask,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-3",
      maskingRegex: /(?<=.).(?=[^@]*?@)|(?:@)([^@]{2})(?=.*\.)/gm,
    },
    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-1",
      component: actionComponent,
    },
  ];
}

export const getAllBranch = async (
  setBranchList: TReactSetState<IBranch[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  search: string,
  advanceSearch: IBranchAdvancedSearch
) => {
  try {
    const branches = await GET_ALL_BRANCH(pagination, search, advanceSearch);
    if (branches && branches.code === DEFAULT_STATUS_CODE_SUCCESS) {
      const branchesListData = JSON.parse(decryptData(branches.data));
      setBranchList(branchesListData.items);
      setPagination(branchesListData.pagination);
    } else {
      setBranchList([]);
      sweetAlertError({
        message: branches.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllBranch");
  }
};

export const getFirmNameDdl = async (
  setFirmName: TReactSetState<IOption<string>[]>
) => {
  try {
    const payload = {
      entity: "firms",
      data_value: "id",
      display_value: "firm_name",
      filters: [
        {
          field: "is_deleted",
          value: "1|0",
          condition: "eq",
        },
      ],
      additional_field: ["is_deleted"],
    };
    const firmNameDDLList = await GLOBAL_DROP_DOWN(payload);
    if (
      firmNameDDLList &&
      firmNameDDLList.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      if (firmNameDDLList.data) {
        setFirmName(firmNameDDLList.data);
      } else {
        setFirmName([]);
      }
    } else {
      toastError(firmNameDDLList.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (e: any) {
    toastError(e?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(e, "getFirmNameDdl");
  }
};
